export const TABLE_COLUMNS = [
  'name',
  'nda',
  'fileAccess',
  'chat',
  'notes',
  'stage',
  'lastSeen',
  'company',
  'added',
  'context',
  'email',
  'phone',
  'referrer',
  'delete',
] as const;

export type LeadsTableColumnsKey = typeof TABLE_COLUMNS[number];

export const SORTING_VALUES: Partial<
  Record<typeof TABLE_COLUMNS[number], string>
> = {
  name: 'sortName',
  stage: 'stageIndex',
  nda: 'ndaIndex',
  chat: 'chatSort',
  fileAccess: 'numberOfAccessableDocuments',
  referrer: 'referrerSortName',
  lastSeen: 'lastSeen',
  added: 'createdAt',
};

export const CUSTOM_COL_SIZES: Partial<
  Record<typeof TABLE_COLUMNS[number], number>
> = {
  name: 210,
  chat: 100,
  notes: 80,
  delete: 80,
  nda: 150,
  fileAccess: 400,
  context: 200,
  phone: 180,
  email: 200,
};

export const SUPER_ADMIN_COLUMNS = ['email', 'phone', 'referrer', 'delete'];

export const REQUIRED_COLUMNS = ['name'];
